import { combineReducers } from "redux";
import userReducer from "./user";
import menuReducer from "./menu";

export default combineReducers({
  user: userReducer,
  menu: menuReducer,
});
